import _ from 'lodash'

import i18n from '@/i18n/i18n'
import { CurrentAccountActivityService } from '@/services/admin/CurrentAccountActivityService'
import RetailerPaymentService from '@/services/admin/RetailerPaymentService'
// eslint-disable-next-line import/no-unresolved
import { QueryBuilder } from '@/utilities/queryBuilder'

const { t } = i18n.global

export const namespaced = true

export const state = {
  activities: [],
  meta: null
}

export const mutations = {
  SET_ACTIVITIES(state, activities) {
    state.activities = _.map(activities.data, activity => {
      return _.extend({ sub: null }, activity)
    })
    state.meta = activities.meta ?? {}
  },
  LOAD_ACTIVITIES(state, activities) {
    _.map(activities.data, activity => {
      state.activities.push(_.extend({ sub: null }, activity))
    })
    state.meta = activities.meta
  },
  SET_RETAILER_ORDER_PAYMENTS(state, params) {
    let row = state.activities.find(activity => activity.id === params.activityId)

    if (!row) {
      return
    }

    row.sub = params.payments
  }
}

export const actions = {
  getActivities({ commit }, data) {
    return new Promise(resolve => {
      let currentAccountActivityService = new CurrentAccountActivityService()

      let queryBuilder = new QueryBuilder()
      let newQuery = queryBuilder

      _.forEach(data.query, function (value, filter) {
        if (filter !== 'page') {
          newQuery.where(filter, value)
        }
      })

      newQuery = queryBuilder.include('salesChannel').page(data.page).get()

      let retailer = data.retailer

      currentAccountActivityService.getActivities(retailer, newQuery).then(response => {
        if (data.page) {
          commit('LOAD_ACTIVITIES', response)
        } else {
          commit('SET_ACTIVITIES', response)
        }
        resolve(response.data)
      })
    })
  },
  getRetailerOrderPayments({ commit }, params) {
    return new Promise(resolve => {
      RetailerPaymentService.getRetailerOrderPayments(params.retailerId, params.paymentId, params.trashed).then(
        response => {
          commit('SET_RETAILER_ORDER_PAYMENTS', {
            activityId: params.activityId,
            payments: response.data
          })
          resolve(response)
        }
      )
    })
  },
  exportCurrentAccountActivity({ dispatch, commit, rootState }, query) {
    return new Promise(resolve => {
      let currentAccountActivityService = new CurrentAccountActivityService()
      let retailerId = query.parameter

      let queryBuilder = new QueryBuilder()
      let newQuery = queryBuilder

      _.forEach(query.query, function (value, filter) {
        if (filter !== 'page') {
          newQuery.where(filter, value)
        }
      })
      newQuery = queryBuilder.include('salesChannel', 'farmer').append('company').page(query.page).get()

      currentAccountActivityService.exportCurrentAccountActivity(retailerId, newQuery).then(response => {
        const notification = {
          type: 'info',
          message: t('store.shared.exporting', {
            element: t('store.admin.retailer.retailer_current_accounts')
          })
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response)
      })
    })
  }
}
